export default __webpack_public_path__ + "static/media/vk.1e7197f2.svg";